import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import LimiteCompra from './LimiteCompra';

class LimiteCompraSelector extends Component {
    constructor(props) {
        super(props);

        this.filterList = this.filterList.bind(this);
        this.checkItem = this.checkItem.bind(this);
        this.checkAllItems = this.checkAllItems.bind(this);
        this.unCheckAllItems = this.unCheckAllItems.bind(this);
        this.checkThisAndAllNext = this.checkThisAndAllNext.bind(this);
        this.saveLimiteCompra = this.saveLimiteCompra.bind(this);
        this.cancelLimiteCompra = this.cancelLimiteCompra.bind(this);
        this.cleanInput = this.cleanInput.bind(this);
        this.changeMassive = this.changeMassive.bind(this);

        this.state = {
            inputValue: undefined,
            LimiteCompraList: undefined,
            filteredList: undefined,
            modalOpen: false
        };
    }

    cleanInput() {
        this.setState({
            inputValue: "",
            filteredList: this.state.LimiteCompraList
        });
    }

    filterList(event) {
        this.setState({ inputValue: event.target.value });

        let updatedList = JSON.parse(JSON.stringify(this.state.LimiteCompraList));
        updatedList = updatedList.filter(function (item) {
            const updatedListValor = item.Valor.toString().toUpperCase().search(
                event.target.value.toString().toUpperCase()) !== -1;
            const updatedListCodigo = item.Codigo.toString().toUpperCase().search(
                event.target.value.toString().toUpperCase()) !== -1;

            return updatedListValor || updatedListCodigo
        });
        this.setState({ filteredList: updatedList });
    }

    checkItem(branchId) {
        let updatedList = JSON.parse(JSON.stringify(this.state.LimiteCompraList));

        let updatedFilteredList = JSON.parse(JSON.stringify(this.state.filteredList));

        let edicion = this.props.edicion;
        updatedList.forEach(function (item) {
            if (item.Id == branchId) {
                item.Checked = !item.Checked;
                if (edicion) {
                    item.Cambio = !item.Cambio;
                }
            }
        })

        updatedFilteredList.forEach(function (item2) {
            if (item2.Id == branchId) {
                item2.Checked = !item2.Checked;
            }
        })


        this.setState({
            filteredList: updatedFilteredList,
            LimiteCompraList: updatedList
        });
    }

    checkAllItems() {
        let updatedList = JSON.parse(JSON.stringify(this.state.LimiteCompraList));
        updatedList = this.changeMassive(updatedList, true);
        this.setState({
            inputValue: "",
            filteredList: updatedList,
            LimiteCompraList: updatedList
        });
    }

    unCheckAllItems() {
        let updatedList = JSON.parse(JSON.stringify(this.state.LimiteCompraList));
        updatedList = this.changeMassive(updatedList, false);
        this.setState({
            inputValue: "",
            filteredList: updatedList,
            LimiteCompraList: updatedList
        });
    }

    changeMassive(list, check) {
        let edicion = this.props.edicion;
        list.forEach(function (item) {
            if (item.Checked != check) {
                item.Checked = check;
                if (edicion) {
                    item.Cambio = !item.Cambio;
                };
            }
        })
        return list;
    }

    saveLimiteCompra() {
        this.props.saveSelectedLimiteCompra(this.state.LimiteCompraList);

        this.setState({
            inputValue: undefined,
            filteredList: undefined,
            LimiteCompraList: undefined,
            modalOpen: false
        });

        $('#LimiteCompraSelector').modal('hide');
    }

    cancelLimiteCompra() {
        this.props.cancelSelectedLimiteCompra();

        this.setState({
            inputValue: undefined,
            filteredList: undefined,
            LimiteCompraList: undefined,
            modalOpen: false
        });

        $('#LimiteCompraSelector').modal('hide');
    }

    checkThisAndAllNext(purchaseLimitId, purchaseLimitValue) {
        let updatedList = JSON.parse(JSON.stringify(this.state.LimiteCompraList));
        let edicion = this.props.edicion;
        updatedList.forEach(function (item) {
            if (item.Valor >= purchaseLimitValue) {
                if (!item.Checked) {
                    if (edicion) {
                        item.Cambio = true;
                    }
                }
                item.Checked = true;
            } else {
                if (item.Checked) {
                    if (edicion) {
                        item.Cambio = true;
                    }
                }
                item.Checked = false;
            }
        })
        this.setState({
            filteredList: updatedList,
            LimiteCompraList: updatedList
        });
    }

    componentDidMount() {
        this.setState({
            filteredList: this.props.data,
            LimiteCompraList: this.props.data
        });
    }

    componentWillReceiveProps(nextProps) {
       // if (this.state.modalOpen === false) {
            this.setState({
                inputValue: "",
                filteredList: nextProps.data,
                LimiteCompraList: nextProps.data,
                modalOpen: true
            });
       // }
    }

    render() {
        let cleanInputSpan = null;
        if (this.state.inputValue != "" && this.state.inputValue != undefined) {
        cleanInputSpan = <div className="buttons-x-top-right"><span id="clearInput" className="btn-x-top-right" onClick={this.cleanInput}>{/*<i className="ti-close"></i>*/}</span></div>;
        }
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="btn-x-top-right-container">
                                <span className="ti-search input-icon-span"></span>
                                <input type="text" placeholder="Buscar por c&oacute;digo o importe" className="form-control default-input input-with-icon" value={this.state.inputValue} onChange={this.filterList} />
                                {cleanInputSpan}
                            </div>
                        </div>
                    </div>
                    <div className="row top-separator-xs">
                        <div className="col-xs-3">
                            <label className="label-3">Seleccionar</label>
                        </div>
                        <div className="col-xs-2">
                            <GenericSimpleButton text="Todas" buttonType="button" buttonClass="btn-link btn-link-secondary" onClick={this.checkAllItems} />
                        </div>
                        <div className="col-xs-2">
                            <GenericSimpleButton text="Ninguna" buttonType="button" buttonClass="btn-link btn-link-secondary" onClick={this.unCheckAllItems} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <LimiteCompra data={this.state.filteredList} checkItem={this.checkItem} checkThisAndAllNext={this.checkThisAndAllNext} />
                        </div>
                    </div>
                    <br />
                    <div className="row top-separator-xs selector-footer">
                        <div className="col-xs-6">
                            <GenericSimpleButton text="Aceptar" buttonType="button" buttonClass="btn btn-cta" onClick={this.saveLimiteCompra} />
                        </div>
                        <div className="col-xs-6">
                            <GenericSimpleButton text="Cancelar" buttonType="button" buttonClass="btn btn-secondary item-pull-right" onClick={this.cancelLimiteCompra} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default LimiteCompraSelector;